import React from 'react';
import { useTranslation } from 'react-i18next';

import { getMimeTypesForExtension } from '../../../../../../nacre/uploadButton/stateless/mimeTypes';

export const useFetchFile = path => {
    const extension = path.split('.').pop();
    const [file, setFile] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);
    const [cache, setCache] = React.useState({});
    const { t } = useTranslation();

    React.useEffect(() => {
        setLoading(true);
        setFile(null);
        setError(null);
        if (cache.path) {
            setFile(cache[path]);
            setLoading(false);
            return;
        }

        if (!['jpg', 'jpeg', 'png', 'gif', 'pdf'].includes(extension)) {
            setError(t(`ticket.moderation.attendee.attachments.fileRejectedText`));
            setLoading(false);
        }

        const abortController = new AbortController();
        const { signal } = abortController;

        fetch(path, { signal })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to load file: ${response.status} ${response.statusText}`);
                }
                return response.blob();
            })
            .then(blob => {
                const mimeTypes = getMimeTypesForExtension(extension);
                const mimeType = mimeTypes.length > 0 ? mimeTypes[0] : 'application/octet-stream';
                const fileBlob = new Blob([blob], { type: mimeType });
                const blobUrl = window.URL.createObjectURL(fileBlob);

                setCache(old => ({ ...old, [path]: blobUrl }));
                setFile(blobUrl);
                setLoading(false);
            })
            .catch(error => {
                if (error.name !== 'AbortError') {
                    setError(error.message);
                    setLoading(false);
                }
            });

        return () => abortController.abort();
    }, [path, extension]);
    return { file, extension, loading, error };
};
